import { FiCheck } from 'react-icons/fi';

import { passwordRequirements } from '../../utils/PasswordPolicy';
import styles from './styles.module.scss';

interface IProps {
  password: string;
}

export const PasswordRequirements = ({ password }: IProps) => (
  <div className={styles.container}>
    <p>Sua senha deve conter:</p>
    <ul>
      {passwordRequirements.map((requirement) => {
        const met = requirement.test(password);
        return (
          <li key={requirement.label} data-met={met}>
            <span className={styles.bullet}>
              {met && <FiCheck size={12} />}
            </span>
            {requirement.label}
          </li>
        );
      })}
    </ul>
  </div>
);
